// ── Excel (CSV) Export ──────────────────────────────────────────────────────

export const exportToCsv = (
  filename: string,
  headers: string[],
  rows: (string | number | null | undefined)[][],
): void => {
  const BOM = '﻿'; // UTF-8 BOM — Excel needs this for correct encoding
  const escape = (cell: string | number | null | undefined): string => {
    if (cell === null || cell === undefined) return '';
    const s = String(cell);
    return s.includes(',') || s.includes('"') || s.includes('\n')
      ? `"${s.replace(/"/g, '""')}"`
      : s;
  };

  const csv = [
    headers.map(escape).join(','),
    ...rows.map(r => r.map(escape).join(',')),
  ].join('\r\n');

  const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// ── PDF (browser print) ─────────────────────────────────────────────────────

export const printReport = (): void => {
  window.print();
};
